<template>
  <div v-if="loaded">
    <section>
      <span v-if="!expired">
        <span v-if="displayDays">
          {{ displayDays }}
          days
          {{ displayHours }}
          hours
          {{ displayMinutes }}
          minutes
          {{ displaySeconds }}
          seconds
        </span>
        <v-progress-circular
          v-else
          :size="15"
          color="white"
          indeterminate
          class="mb-1"
        ></v-progress-circular>
      </span>

      <span v-else>EXPIRED</span>
    </section>
  </div>
</template>

<script>
export default {
  data: () => ({
    loaded: true,
    displayDays: 0,
    displayHours: 0,
    displayMinutes: 0,
    displaySeconds: 0,
    expired: false
  }),
  props: ['year', 'month', 'date', 'hour', 'minute', 'second', 'milisecond'],
  computed: {
    _seconds: () => 1000,
    _minutes () {
      return this._seconds * 60
    },
    _hours () {
      return this._minutes * 60
    },
    _days () {
      return this._hours * 24
    },
    end () {
      return new Date(
        this.year,
        this.month - 1, // In javascript, first month (January) is notated with 0
        this.date,
        this.hour,
        this.minute,
        this.second,
        this.milisecond
      )
    }
  },
  mounted () {
    this.showRemaining()
  },
  methods: {
    showRemaining () {
      const timer = setInterval(() => {
        const now = new Date()
        const distance = this.end.getTime() - now.getTime()

        if (distance < 0) {
          clearInterval(timer)
          this.expired = true
          return
        }

        const days = Math.floor(distance / this._days)
        const hours = Math.floor((distance % this._days) / this._hours)
        const minutes = Math.floor((distance % this._hours) / this._minutes)
        const seconds = Math.floor((distance % this._minutes) / this._seconds)
        this.displaySeconds = seconds < 10 ? '0' + seconds : seconds
        this.displayMinutes = minutes < 10 ? '0' + minutes : minutes
        this.displayHours = hours < 10 ? '0' + hours : hours
        this.displayDays = days < 10 ? '0' + days : days
      }, 1000)
    }
  }
}
</script>
